module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2026-08-05 at 10.39.03 (2).a5bf58c3.jpeg";